'use strict';

var EditWifi = require('actionGroups/editWifi/EditWifi');
var FormView = require('actionGroups/editWifi/EditWifiView');

module.exports = {
  Model: EditWifi,
  GroupView: FormView,
};
